import { mockDataArrivalReport, mockDataDepartureReport, mockDataNoonReport } from '../../local_modules/reports/src/mock-data'
import { ReportValues } from '../../local_modules/reports/type/modal-for-report-type'
import { authFetchGET, authFetchPOST, authFetchPUT } from '../utils/auth-fetch'

const env = (<any>window)['appenv'].services.schedulesapi
const env2 = (<any>window)['appenv'].services.weatherRoutingApi

export const WeatherRouting = new (class extends EventTarget {
    async getWRStatus(
        departureTerminalCode: string,
        arrivalTerminalCode: string,
        scheduleId: string,
    ) {
        const url: string = `${env.baseurl}/weatherroutingstatus?departureTerminalCode=${departureTerminalCode}&arrivalTerminalCode=${arrivalTerminalCode}&scheduleId=${scheduleId}`
        try {
            const response = await authFetchGET(env.scope, url)

            if (Array.isArray(response) && response.length === 0) {
                return null
            } else {
                return response
            }
        } catch (error) {
            console.warn(
                'There has been a problem with your fetch operation:',
                error,
            )
        }
    }

    // ArrivalReport
    async getEospReport(scheduleId: string) {
        const url : string = `${env2.baseurl}/ArrivalReport/get-calculated-report/${scheduleId}`
        try {
            const eospResponse = await authFetchGET(env.scope, url)
            console.log(eospResponse, 'getEospReport response')
            return eospResponse
        } catch (error) {
            console.warn(
                'There has been a problem with your fetch operation:',
                error,
            )
        }
    }

    async getSospReport(scheduleId: string) {
        const url: string = `${env2.baseurl}/DepartureReport/get-calculated-report/${scheduleId}`
        try {
            const sospResponse = await authFetchGET(env.scope, url)
            console.log(sospResponse, 'getSospReport response')
            return sospResponse
        } catch (error) {
            console.warn(
                'There has been a problem with your fetch operation:',
                error,
            )
        }
    }

    async getNoonReport(scheduleId: string, id: number) {
        const url: string = `${env2.baseurl}/NoonReport/get-calculated-report/${scheduleId}/report/${id}`
        try {
            const noonResponse = await authFetchGET(env.scope, url)
            console.log(noonResponse, 'getNoonReport response')
            return noonResponse
        } catch (error) {
            console.warn(
                'There has been a problem with your fetch operation:',
                error,
            )
        }
    }

    async postArrivalReport(scheduleId: string) {
        // eosp
        const url: string = `${env2.baseurl}/ArrivalReport/schedule/${scheduleId}`
        return await authFetchPOST(env.scope, url, {})
    }

    async putArrivalReport(payload: ReportValues) {
        // eosp
        const url: string = `${env2.baseurl}/ArrivalReport/${payload.id}`
        try {
            return await authFetchPUT(env.scope, url, payload)
        } catch (err) {
            console.warn(`${err}`)
            return null
        }
    }

    async submitArrivalReport(payload: ReportValues) {
        // eosp
        const url: string = `${env2.baseurl}/ArrivalReport/submit`
        try {
            return await authFetchPOST(env.scope, url, payload)
        } catch (err) {
            console.warn(`${err}`)
            return null
        }
    }

    async postDepartureReport(scheduleId: string) {
        // sosp
        const url: string = `${env2.baseurl}/DepartureReport/schedule/${scheduleId}`
        try {
            return await authFetchPOST(env.scope, url, {})
        } catch (err) {
            console.warn(`${err}`)
            return null
        }
    }

    async putDepartureReport(payload: ReportValues) {
        // sosp
        const url: string = `${env2.baseurl}/DepartureReport/${payload.id}`
        try {
            return await authFetchPUT(env.scope, url, payload)
        } catch (err) {
            console.warn(`${err}`)
            return null
        }
    }

    async submitDepartureReport(payload: ReportValues) {
        // sosp
        const url: string = `${env2.baseurl}/DepartureReport/submit`
        try {
            return await authFetchPOST(env.scope, url, payload)
        } catch (err) {
            console.warn(`${err}`)
            return null
        }
    }

    async postNoonReport(scheduleId: string) {
        // noon
        const url: string = `${env2.baseurl}/NoonReport/schedule/${scheduleId}`
        try {
            return await authFetchPOST(env.scope, url, {})
        } catch (err) {
            console.warn(`${err}`)
            return null
        }
    }

    async putNoonReport(payload: ReportValues) {
        // noon
        const url: string = `${env2.baseurl}/NoonReport/${payload.id}`
        try {
            return await authFetchPUT(env.scope, url, payload)
        } catch (err) {
            console.warn(`${err}`)
            return null
        }
    }

    async submitNoonReport(payload: ReportValues) {
        // noon
        const url: string = `${env2.baseurl}/NoonReport/submit`
        try {
            return await authFetchPOST(env.scope, url, payload)
        } catch (err) {
            console.warn(`${err}`)
            return null
        }
    }

    async getReportIdPagination(scheduleId: string) {
        const url: string = `${env2.baseurl}/NoonReport/get-report-ids/schedule/${scheduleId}`
        try {
            const reportIdsResponse = await authFetchGET(env.scope, url)
            console.log(reportIdsResponse, 'reportIdsResponse response')
            return reportIdsResponse
        } catch (error) {
            console.warn(
                'There has been a problem with your fetch operation:',
                error,
            )
        }
    }

    async checkIfReportExists(scheduleId: string, reportType: string) {
        const url: string = `${env2.baseurl}/${reportType}Report/get-report-ids/schedule/${scheduleId}`
        try {
            const reportExistsResponse = await authFetchGET(env.scope, url)
            console.log(reportExistsResponse, 'reportExistsResponse response')
            return reportExistsResponse
        } catch (error) {
            console.warn(
                'There has been a problem with your fetch operation:',
                error,
            )
        }
    }
})()
